import { get } from "react-hook-form";
import { getUsersFormAssets } from "../repositories/FormsRepository";
import { useFormsContext } from "../context/FormsContext";
type Props = {
	setIsLoading: (isLoading: boolean) => void;
	setError: (err: string) => void;
	FormAssetIdToSearchUserFormAssets: number;
};

export const useSearchUsersFormAsset = ({
	setIsLoading,
	setError,
	FormAssetIdToSearchUserFormAssets,
}: Props) => {
	const {
		actions: { setUsersFormAssetList },
	} = useFormsContext();

	return async () => {
		setUsersFormAssetList([]);
		setIsLoading(true);
		const res = await getUsersFormAssets(FormAssetIdToSearchUserFormAssets);
		if (res.ok) {
			const rowsSource = get(res, "data.tables[0].rows", []);
			if (rowsSource.length) {
				setUsersFormAssetList(rowsSource);
			} else {
				setUsersFormAssetList(null);
			}
			setIsLoading(false);
		} else {
			setError(res.message);
			setIsLoading(false);
		}
	};
};
